export enum introAssetConfig {
    introBG = "assets/introscreen/fg_outro_base.png",
    INTRO_BTNS = "assets/introscreen/post_intro_start_btn_1.json",
    outroBg = "assets/introscreen/fg_outro_base.png",

}